import React, { useEffect, useState } from "react";
import "./Sidebar.css";
import dashboardActiveIcon from "../../assets/sidebar/dashboard-black.svg";
import logout from "../../assets/logout.svg";
import logo from "../../assets/kgplainlogo.svg";
import { NavLink, useNavigate } from "react-router-dom";
import { showAlert } from "../utills/sweetAlert";
import productblack from "../../assets/sidebar/productblack.svg";
import finblack from "../../assets/sidebar/finblack.svg";
import subblack from "../../assets/sidebar/subscriberblack.svg";
import avatarmale from "../../assets/international-literacy-day-abstract-vector-illustration-design_828584-357.jpg";
import dashboardsvg from "../../assets/sidebar/dashboard.svg";
import productsvg from "../../assets/sidebar/product.svg";
import subwhite from "../../assets/sidebar/subscriberwhite.svg";
import finwhite from "../../assets/sidebar/finwhite.svg";
import memblack from "../../assets/sidebar/memblack.svg";
import memwhite from "../../assets/sidebar/memwhite.svg";
import testmonials from "../../assets/sidebar/settblack.svg";
import testmonialsw from "../../assets/sidebar/settwhite.svg";
import wblack from "../../assets/sidebar/banwhite.svg";
import bblack from "../../assets/sidebar/banblack.svg";
import contact from "../../assets/Contact us b.svg";
import contactw from "../../assets/Contact us w.svg";
import quick from "../../assets/sidebar/notblack.svg";
import quickw from "../../assets/sidebar/notwhite.svg";

const Sidebar: React.FC = () => {
  const navigate = useNavigate();
  const [isOpen, setIsOpen] = useState(true);
  const [activeMenu, setActiveMenu] = useState(() => {
    return localStorage.getItem("activeMenu") || "Dashboard";
  });
  const [isOpenReport, setIsOpenReport] = useState(false);
  const [activeReportMenu, setActiveReportMenu] = useState(() => {
    return localStorage.getItem("activeReportMenu") || "";
  });
  const [userName, setUsername] = useState("Welcome");

  useEffect(() => {
    const storedUserDetails: any = sessionStorage.getItem('userDetails');
    const userDetails = JSON.parse(storedUserDetails);
    setUsername(userDetails?.userName);
  });

  useEffect(() => {
    localStorage.setItem("activeMenu", activeMenu);
    localStorage.setItem("activeReportMenu", activeReportMenu);
  }, [activeMenu, activeReportMenu]);

  const toggleSidebar = () => {
    setIsOpen(!isOpen);
  };
  const toggleReport = () => {
    setIsOpenReport(!isOpenReport);
  };

  const handleMenuClick = async (menu: string) => {
    localStorage.setItem("activeMenu", menu);
    await setActiveMenu(menu);
    if (menu != "Reports") {
      setIsOpenReport(false);
      setActiveReportMenu("");
      localStorage.setItem("activeReportMenu", '');
    }
  };
 

  const storedUserDetails: any = sessionStorage.getItem('userDetails');
  const userDetails = JSON.parse(storedUserDetails);
  const userType = "0";

  const handleLogoutone = async () => {
    const isComfirm = await showAlert("Please Confirm", "Are you sure you want to Logout ?", "Yes", "No")
    if (isComfirm) {
      sessionStorage.removeItem('authkey'); 
        navigate("/");
        localStorage.clear();
        sessionStorage.clear();
    }
  }
  const username = sessionStorage.getItem('useremail');
  const [isConfirmationModalOpen, setIsConfirmationModalOpen] = useState(false);

  return (
    <div className={`sidebar ${isOpen ? "open" : "closed"}`}>
      <div className="sidebar-header">
        <div className="header-content">
          <div className="sidebar-heading">
            <div className="d-flex">
              <img src={logo} alt="Logo" />
              {isOpen && <span className="profile-name">{userName}</span>}
            </div>
          </div>
          <div className="sidebar-toggle" onClick={toggleSidebar}>
          </div>
        </div>
      </div>
      <hr className="horizontal-line" />
      <div className="sidebar-header">
      </div>
      <div className="sibebarcontent">
      <ul className="sidebar-menu" style={{ paddingLeft: isOpen ? "5%" : "15%" }}>
        <li
          >
          <NavLink
            // className="menu-button"
            className={`menu-button ${activeMenu == 'Pages' && 'active'}`}
            to="/layout/mainDashboard"
            onClick={() => handleMenuClick("Pages")}
          >
            <img
              src={activeMenu === "Pages" ? dashboardsvg : dashboardActiveIcon}
              alt="dashboard"
              className="menu-icon-dash"
            />{" "}
            {isOpen && <span style={{ color: activeMenu === "Pages" ? "#ffffff" : "#000000", marginLeft: "10px",fontSize:"16px" }}>Pages</span>}
          </NavLink>
        </li>

        <li>
            <NavLink
            className={`menu-button ${activeMenu == 'Gallery' && 'active'}`}
              style={{
                color: activeMenu === "Gallery" ? "#000000" : "#595959",
              }}
              to="/layout/gallery"
              onClick={() => handleMenuClick("Gallery")}
            >
              <img
                src={activeMenu === "Gallery" ? finwhite : finblack}
                alt="Gallery"
                    className="menu-icon-dash"
              />{" "}
                          {isOpen && <span style={{ color: activeMenu === "Gallery" ? "#ffffff" : "#000000", marginLeft: "10px",fontSize:"16px" }}>Gallery</span>}
            </NavLink>
          </li>
          <li>
            <NavLink
              className="menu-button"
              style={{
                color: activeMenu === "SubCategory" ? "#000000" : "#595959",
              }}
              to="/layout/Category"
              onClick={() => handleMenuClick("SubCategory")}
            >
              <img
                              src={activeMenu === "SubCategory" ? memwhite : memblack}
                alt="Gallery"
                    className="menu-icon-dash"
              />{" "}
                          {isOpen && <span style={{ color: activeMenu === "SubCategory" ? "#ffffff" : "#000000", marginLeft: "10px",fontSize:"16px" }}>SubCategory</span>}

            </NavLink>
          </li>

        <li
       >
            <NavLink
            className={`menu-button ${activeMenu == 'Careers' && 'active'}`}
              to="/layout/Careers"
              onClick={() => handleMenuClick("Careers")}
            >
              <img
                src={activeMenu === "Careers" ? productsvg : productblack}
                alt="Careers"
                    className="menu-icon-dash"
              />{" "}
              {isOpen && <span style={{ color: activeMenu === "Careers" ? "#ffffff" : "#000000", marginLeft: "10px",fontSize:"16px" }}>Careers</span>}
            </NavLink>
          </li>

          <li >
            <NavLink
            className="menu-button"
              to="/layout/Info"
              onClick={() => handleMenuClick("Info")}
            >
              <img
                src={activeMenu === "Info" ? subwhite : subblack}
                alt="Subscribers"
                    className="menu-icon-dash"
              />{" "}
                           {isOpen && <span style={{ color: activeMenu === "Info" ? "#ffffff" : "#000000", marginLeft: "10px",fontSize:"16px" }}>Info</span>}
            </NavLink>
          </li>

          <li>
            <NavLink
            className={`menu-button ${activeMenu == 'Blog' && 'active'}`}
              to="/layout/Blog"
              onClick={() => handleMenuClick("Blog")}
            >
              <img
                src={activeMenu === "Blog" ? wblack : bblack}
                alt="Subscribers"
                    className="menu-icon-dash"
              />{" "}
                           {isOpen && <span style={{ color: activeMenu === "Blog" ? "#ffffff" : "#000000", marginLeft: "10px",fontSize:"16px" }}>Blog</span>}
            </NavLink>
          </li>
         
          <li>
            <NavLink
              className="menu-button"
              style={{
                color: activeMenu === "Testimonials" ? "#000000" : "#595959",
              }}
              to="/layout/Testimonials"
              onClick={() => handleMenuClick("Testimonials")}
            >
              <img
                              src={activeMenu === "Testimonials" ? testmonialsw : testmonials}
                alt="Gallery"
                    className="menu-icon-dash"
              />{" "}
                          {isOpen && <span style={{ color: activeMenu === "Testimonials" ? "#ffffff" : "#000000", marginLeft: "10px",fontSize:"16px" }}>Testimonials</span>}

            </NavLink>
          </li>
          <li>
            <NavLink
              className="menu-button"
              style={{
                color: activeMenu === "ContactUs" ? "#000000" : "#595959",
              }}
              to="/layout/ContactUs"
              onClick={() => handleMenuClick("ContactUs")}
            >
              <img
                              src={activeMenu === "ContactUs" ? contactw : contact}
                alt="Gallery"
                    className="menu-icon-dash"
              />{" "}
                          {isOpen && <span style={{ color: activeMenu === "ContactUs" ? "#ffffff" : "#000000", marginLeft: "10px",fontSize:"16px" }}>ContactUs</span>}
            </NavLink>
          </li>

          <li>
            <NavLink
              className="menu-button"
              style={{
                color: activeMenu === "Quick Reach" ? "#000000" : "#595959",
              }}
              to="/layout/QuickReach"
              onClick={() => handleMenuClick("Quick Reach")}
            >
              <img
                              src={activeMenu === "Quick Reach" ? quickw : quick}
                alt="Gallery"
                    className="menu-icon-dash"
              />{" "}
                          {isOpen && <span style={{ color: activeMenu === "Quick Reach" ? "#ffffff" : "#000000", marginLeft: "10px",fontSize:"16px" }}>Quick Reach</span>}
            </NavLink>
          </li>
      </ul>
      </div>
      <footer className="sidebar-footer">
      <ul className="sidebar-menuone">
        <li>
          <button
            className="menu-button"
            style={{
              backgroundColor: activeMenu === "user" ? "#642d97" : "#fff",
              color: activeMenu === "user" ? "#fff" : "black",
              alignItems:"unset"
            }}
            onClick={() => setIsConfirmationModalOpen(true)} // Open confirmation modal on click
          >
            <img src={avatarmale} alt="dashboard" style={{ width: "50px" }} />{" "}
            {isOpen && (
              <span style={{ fontSize: "16px", color: "#444444" }}>
             Admin
              </span>
            )}
          </button>
          {isOpen && (
            <span
              style={{
                fontSize: "16px",
                color: "#444444",
                position: "absolute",
                left: "73px",
                marginTop: "-36px",
              }}
            >
              {username}
            </span>
          )}
        </li>
        <li>
         
          <div>
            <button className="logout-button"
            onClick={handleLogoutone}>
              <img src={logout} alt="Out" className="logouticon" />
              <span className="logout-text">Logout</span>
            </button>
          </div>
        </li>
      </ul>
</footer>
    </div>
  );
};

export default Sidebar;
